import React from 'react';
import { getBonus } from '../../utils';
import { Incentive } from '../Incentive';
export const MakeYourFirstSalesIncentive = ({ incentive }) => {
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83D\uDCB5", label: `Make your first ${incentive.amountToMake} sales`, isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus) }));
};
